import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out
  const token = localStorage.getItem("pe_token");

  useEffect(() => {
    // Handle return from Emergent Google OAuth (session_id in URL fragment)
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const hash = window.location.hash;
    if (hash && hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } })
        .then((res) => {
          localStorage.setItem("pe_token", res.data.token);
          setUser(res.data.user);
        })
        .catch(() => { setUser(false); })
        .finally(() => {
          window.history.replaceState(null, "", window.location.pathname);
        });
      return;
    }
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => { localStorage.removeItem("pe_token"); setUser(false); });
  }, [token]);

  const login = (data) => {
    localStorage.setItem("pe_token", data.token);
    setUser(data.user);
  };
  const logout = () => {
    localStorage.removeItem("pe_token");
    setUser(false);
  };
  const refreshUser = async () => {
    const res = await api.get("/auth/me");
    setUser(res.data);
    return res.data;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}
